import React from 'react'
import "./Policy.css";
import { Helmet } from "@dr.pogodin/react-helmet";

function TermsAndCondition() {
  return (
    <div className='ppMn'>
      <Helmet>
        <title>Terms & Conditions | PAYTECH ADVISOR</title>
      </Helmet>

      <div className="ppCon">
        <div className="maxW">
          <h1>Terms & Conditions</h1>

          <div className="ppSection">
            <h2>Eligibility</h2>
            <ul>
              <li>Users must be at least 18 years of age and capable of entering into legally binding agreements.</li>
              <li>All information provided by the user must be accurate, complete, and up to date.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Services</h2>
            <ul>
              <li>Paytech Advisors provides consulting and advisory services in payments, technology, marketing, and business growth strategies, including facilitation of service delivery through third-party alliances.</li>
              <li>Paytech Advisors is not a bank, payment gateway, or financial institution. All financial transactions are facilitated exclusively through licensed third-party partners, duly registered under the Companies Act or other applicable laws of the land.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>User Responsibilities</h2>
            <ul>
              <li>Users agree not to misuse our Services or engage in unlawful activities.</li>
              <li>Unauthorized reproduction, distribution, or resale of our Services is strictly prohibited.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Intellectual Property</h2>
            <ul>
              <li>All content, materials, trademarks, and logos available on our Site and Services are the intellectual property of Paytech Advisors or are used with authorization from our partners.</li>
              <li>No copying, reproduction, or distribution is permitted without prior written consent from Paytech Advisors or the respective rights holders.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Limitation of Liability</h2>
            <ul>
              <li>Paytech Advisors does not guarantee uninterrupted or error-free services.</li>
              <li>The Company shall not be liable for any indirect, incidental, or consequential damages.</li>
              <li>KYC checks, agreements, service delivery, and related offerings are executed by third-party partners.</li>
              <li>Paytech Advisors has zero liability for damages, chargebacks, refunds, or disputes related to third-party services or products.</li>
            </ul>
          </div>

          <div className="ppSection">
            <h2>Governing Law</h2>
            <ul>
              <li>These Terms shall be governed by the laws of India.</li>
              <li>All disputes shall be subject to the exclusive jurisdiction of the courts at Mainpuri, Uttar Pradesh – 205001.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  )
}

export default TermsAndCondition;
